import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IApplicationUser, IMenuByUserResponse } from './menu-by-user.model';
import { HttpClientRequestService } from '@core/request-services/httpclient.request.services';
import { EndpointConstants } from '@core/services/endpoints-configurations/endpoint-constants';
import { getDarkLogoSrc } from '@shared/helpers/dark-mode';

@Injectable({
  providedIn: 'root',
})
export class MenuByUserApiService {
  constructor(private repo: HttpClientRequestService) {}

  getMenusByUser(request: IApplicationUser): Observable<IMenuByUserResponse> {
    const url: string = EndpointConstants.ApiMenusByUser2;
    return this.repo.post(url, request).pipe(
      map((response: any) => {
        if (response && response.applicationMenus) {
          response.applicationMenus = response.applicationMenus.map((item: any) => {
            if (!item.logo) return item;
            const logoDark = getDarkLogoSrc(item.logo);
            return { ...item, logoDark };
          });
        }
        return response as IMenuByUserResponse;
      }),
    );
  }
}
